import { faCodepen } from '@fortawesome/free-brands-svg-icons';
import { faObjectGroup } from '@fortawesome/free-regular-svg-icons';
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const services = [
    { icon: faLaptopCode, title: 'Web Development', description: 'Transforming ideas into impactful, high-performance web solutions ' },
    { icon: faCodepen, title: 'Software Development', description: 'Custom software solutions that enhance productivity and efficiency.' },
    { icon: faObjectGroup, title: 'Web Design', description: 'Creative and user-friendly designs that make your website stand out.' }
];

const MyService = () => {
    return (
        <>
            <h2><span className='text-blue-500 pt-2'>M</span>y Service</h2>
            <hr />
            <div className="flex flex-wrap pb-2">
                {services.map((service, index) => (
                    <div key={index} className="sm:w-1/3 p-2">
                        <div className="max-w-sm p-6 mt-4 bg-white border border-gray-200 rounded-lg shadow-2xl hover:border-blue-700 text-center">
                            <FontAwesomeIcon icon={service.icon} className="text-blue-500 text-3xl text-semibold" />
                            <h3 >{service.title}</h3>
                            <p className='font-extralight'>{service.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default MyService;
